import { render, staticRenderFns } from "./DashboardError.vue?vue&type=template&id=13cf5c28&scoped=true&"
import script from "./DashboardError.vue?vue&type=script&lang=ts&"
export * from "./DashboardError.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardError.vue?vue&type=style&index=0&id=13cf5c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf5c28",
  null
  
)

export default component.exports